import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { networkCall } from "./Network";
export const fetchDoctorBookings = createAsyncThunk(
  "bookings/fetch",
  async (payload) => {
    const response = await networkCall(
      "GET",
      `/api/clinic_mobile_opd/Appointments/slots_taken?clinic_id=${localStorage.getItem('clinic_id')}&doctor_id=${payload?.doctorId}&date=${payload?.date}&MDT=CM`
    );

    return response.data;
  }
);
export const fetchDoctorBookingsSlots = createAsyncThunk(
  "bookings/fetch",
  async (payload) => {
    const response = await networkCall(
      "GET",
      ` /api/clinic_mobile_opd/Appointments/book_appointmentsview_appointments_by_date?clinic_id=${localStorage.getItem('clinic_id')}
      )}&doctorId=${payload?.doctorId}&date=${payload?.date}&MDT=CM`
    );
    return response.data;
  }
);

const token = localStorage.getItem('token')
const headers = {
  Authorization: `Bearer ${token}`,
}
const user_role = localStorage.getItem('user_role')

export const fetchSchedule = createAsyncThunk(
  "bookings/fetchSchedue",
  async (payload) => {
    const response = await networkCall(
      "GET",
      `/api/clinic_mobile_opd/Doctors/slots?doctorsId=${payload?.doctorId}&clinic_id=${payload?.clinicId}&MDT=CM`
    );
    if (response.status === 1) {
      return response.data;
    }
    throw new Error("Something Went Wrong");
  }
);

export const addSchedule = createAsyncThunk(
  "bookings/schedule",
  async (payload) => {
    try {
      let formData = new FormData();
      formData.append("array_data", JSON.stringify(payload));
      formData.append('MDT', 'CM');
      formData.append('user_role', user_role);
      formData.append('clinic_id', localStorage.getItem('clinic_id'));
      formData.append('loggedin_user_id', localStorage.getItem('user_id'));
      const response = await fetch(global.baseUrl + "/api/clinic_mobile_opd/Appointments/add_schedule", {
        method: "POST",
        body: formData,
        headers: headers,
        processData: false,
        contentType: false,
      });
      const data = await response.text();
      const refreshedToken = data.response_token
      if (refreshedToken) {
        localStorage.setItem('token', refreshedToken)
        headers.Authorization = `Bearer ${refreshedToken}`
        console.log('Token refreshed successfully:', refreshedToken)
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
);
const BookingSlice = createSlice({
  name: "bookings",
  initialState: {
    error: null,
    loading: false,
    bookingList: [],
    slotList: [],
  },
  reducers: {
    mutateSlotList(state, action) {
      console.log(action.payload);
      state.slotList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorBookings.pending, (state) => {
        state.loading = true;
        state.bookingList = [];
        state.error = null;
      })
      .addCase(fetchDoctorBookings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
        alert(action?.error);
      })
      .addCase(fetchDoctorBookings.fulfilled, (state, action) => {
        state.loading = false;
        state.bookingList = action.payload;
      });

    builder
      .addCase(addSchedule.pending, (state) => {
        state.loading = true;
      })
      .addCase(addSchedule.rejected, (state, action) => {
        alert(action.error.message);
        state.loading = false;
      })
      .addCase(addSchedule.fulfilled, (state) => {
        state.loading = false;
        alert("Slots Added Successfully");
      });

    builder
      .addCase(fetchSchedule.pending, (state) => {
        state.loading = true;
        state.slotList = [];
      })
      .addCase(fetchSchedule.rejected, (state, action) => {
        state.loading = false;
        alert(action.error?.message || "");
      })
      .addCase(fetchSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.slotList = action?.payload || [];
      });
  },
});

export const { mutateSlotList } = BookingSlice.actions;
export default BookingSlice.reducer;
